var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 39,
    viewBox: "0 0 42 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.2C0 2.32812 2.35051 0 5.25 0H23.625C26.5245 0 28.875 2.32812 28.875 5.2V15.6C28.875 18.4719 26.5245 20.8 23.625 20.8H18.375L10.5 28.6V20.8H5.25C2.35051 20.8 0 18.4719 0 15.6V5.2Z",
    fill: "#6C2BD9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.125 10.4V22C34.125 24.2091 32.3341 26 30.125 26H20.5496L15.912 30.5934C16.6465 30.9806 17.4849 31.2 18.375 31.2H23.625L31.5 39V31.2H36.75C39.6495 31.2 42 28.8719 42 26V15.6C42 12.7281 39.6495 10.4 36.75 10.4H34.125Z",
    fill: "#6C2BD9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.b9078d6f2ef73bd6a11536acd5fd6f04.svg";
export { ForwardRef as ReactComponent };